module.exports = __webpack_public_path__ + "img/Menu-Shipping.03734ae6.svg";